import * as XLSX from 'xlsx';
import { FileResultType } from '../../../Helper/file';
import { BulkAWBFailedRecord, BulkAWBType } from './types';

export const readXslAndGetBulkAWBUploadObject = (data: FileResultType[]): BulkAWBType[] => {
  if (!data?.length) {
    throw { msg: 'Please upload AWB sheet.' };
  }

  const file = data[0];

  // Check if fileData exists
  if (!file.fileData || !(file.fileData instanceof Array) || file.fileData.length === 0) {
    throw { msg: 'File data is missing' };
  }

  const sheetData = file.fileData[0];

  // Convert the array data into a worksheet
  const worksheetData = sheetData.data;

  if (!worksheetData || worksheetData.length < 2) {
    throw { msg: 'Sheet is empty or has no data rows.' };
  }

  // Extract headers (first row)
  const headers = worksheetData[0];
  console.info('Headers:', headers);

  // Create worksheet object
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Convert to JSON
  const jsonData: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });

  if (!jsonData.length) {
    throw { msg: 'Sheet is empty.' };
  }

  if (jsonData.length > 500) {
    throw {
      msg: 'You can upload a maximum of 500 shipments at a time. Please reduce the number of shipments and try again.',
    };
  }

  const parsedData: BulkAWBType[] = [];

  const getRowValue = (row: any, keys: string[]) => {
    for (const key of keys) {
      if (row[key] !== undefined && row[key] !== null && row[key] !== '') {
        return row[key].toString().trim();
      }
    }
    const rowKeys = Object.keys(row);
    for (const targetKey of keys) {
      const matchedKey = rowKeys.find(k => k.trim().toLowerCase() === targetKey.toLowerCase());
      if (matchedKey && row[matchedKey] !== undefined && row[matchedKey] !== null && row[matchedKey] !== '') {
        return row[matchedKey].toString().trim();
      }
    }
    return '';
  };

  jsonData.forEach((row, index) => {
    const shipmentNumber = getRowValue(row, ['Shipment Number', 'shipmentNumber', 'Shipment number']);
    const awbNumber = getRowValue(row, ['AWB Number', 'awbNumber', 'AWB number', 'AWB', 'awb']);

    if (!shipmentNumber || !awbNumber) {
      throw {
        msg: `Shipment Number / AWB Number missing at row ${index + 2}`,
      };
    }

    parsedData.push({
      shipmentNumber,
      awbNumber,
    });
  });

  return parsedData;
};

export const exportFailedAWBRecords = (failedRecords: BulkAWBFailedRecord[]) => {
  if (!failedRecords || !failedRecords.length) return;

  const headers = [['Shipment Number', 'AWB Number', 'Failure Reason']];
  const rows = failedRecords.map(item => [item.shipmentNumber || '', item.awbNumber || '', item.failureReason || '']);

  const worksheetData = [...headers, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Column width
  worksheet['!cols'] = [{ wch: 25 }, { wch: 25 }, { wch: 60 }];

  // Freeze Header Row
  worksheet['!freeze'] = {
    xSplit: 0,
    ySplit: 1,
  };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Failed Records');

  XLSX.writeFile(workbook, 'Bulk_AWB_Upload_Failed_Records.xlsx');
};
